/* eslint-disable linebreak-style */
/* eslint-disable import/extensions */
/* eslint-disable react/jsx-props-no-spreading */
/* eslint-disable react/jsx-filename-extension */
import React, { Component } from 'react';

import {
  Portfolios, Testimonials,
} from 'json/landingPageData';
import Header from 'parts/Header';
import FloraiHero from 'parts/florai/FloraiHero';
import FloraiScrollDemo from 'parts/florai/FloraiScrollDemo';
import FloraiShowcase from 'parts/florai/FloraiShowcase';
import FloraiSafety from 'parts/florai/FloraiSafety';
import FloraiDownload from 'parts/florai/FloraiDownload';
import Partners from 'parts/Partners';
import Achievement from 'parts/Achievement';
import FeaturedApps from 'parts/FeaturedApps';
import Portfolio from 'parts/Portfolio';
import TeamPreview from 'parts/TeamPreview';
import Testimonial from 'parts/Testimonial';
import Discuss from 'parts/Discuss';
import Footer from 'parts/Footer';

export default class LandingPage extends Component {
  componentDidMount() {
    window.scrollTo(0, 0);
  }

  render() {
    return (
      <>
        <Header />
        <FloraiHero />
        <FloraiScrollDemo />
        <FloraiShowcase />
        <FloraiSafety />
        <FloraiDownload />
        <Partners />
        <Achievement />
        <FeaturedApps />
        <Portfolio data={Portfolios} />
        <TeamPreview />
        <Testimonial data={Testimonials} />
        <Discuss />
        <Footer />
      </>
    );
  }
}
